import React from 'react';

import Icon from '@atlaskit/icon';
import type { CustomGlyphProps, IconProps } from '@atlaskit/icon/types';

const HeartbeatsIconGlyph = (props: CustomGlyphProps) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		data-testid={props['data-testid']}
		aria-label={props['aria-label']}
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		className={props.className}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.0001 9.43995L13.7601 7.69595C14.2289 7.23305 14.8613 6.97348 15.5201 6.97348C16.179 6.97348 16.8113 7.23305 17.2801 7.69595C17.511 7.92394 17.6943 8.19549 17.8194 8.49487C17.9445 8.79425 18.0089 9.11548 18.0089 9.43995C18.0089 9.76442 17.9445 10.0857 17.8194 10.385C17.6943 10.6844 17.511 10.956 17.2801 11.184L12.0001 16.417L6.72012 11.185C6.48894 10.9569 6.30537 10.6853 6.18008 10.3857C6.05479 10.0861 5.99027 9.76466 5.99027 9.43995C5.99027 9.11524 6.05479 8.79377 6.18008 8.49421C6.30537 8.19465 6.48894 7.92297 6.72012 7.69495C7.18895 7.23205 7.82127 6.97249 8.48011 6.97249C9.13896 6.97249 9.77129 7.23205 10.2401 7.69495V7.69595L12.0001 9.43995ZM5.31612 12.583L5.31912 12.587L11.6411 18.853C11.7364 18.9481 11.8655 19.0015 12.0001 19.0015C12.1347 19.0015 12.2639 18.9481 12.3591 18.853L18.6811 12.587L18.6841 12.583L18.6881 12.58C19.1039 12.1695 19.434 11.6806 19.6594 11.1416C19.8847 10.6026 20.0007 10.0242 20.0007 9.43995C20.0007 8.85573 19.8847 8.27732 19.6594 7.73829C19.434 7.19927 19.1039 6.71036 18.6881 6.29995C17.8442 5.46673 16.706 4.99951 15.5201 4.99951C14.3342 4.99951 13.196 5.46673 12.3521 6.29995L12.3491 6.30395L12.3451 6.30695L12.0001 6.64995L11.6551 6.30795L11.6511 6.30495L11.6481 6.30195C10.8042 5.46873 9.66604 5.00151 8.48011 5.00151C7.29419 5.00151 6.15601 5.46873 5.31212 6.30195C4.89648 6.71235 4.56646 7.20119 4.34122 7.74012C4.11598 8.27905 4 8.85735 4 9.44145C4 10.0256 4.11598 10.6039 4.34122 11.1428C4.56646 11.6817 4.89648 12.1706 5.31212 12.581L5.31612 12.584V12.583Z"
		/>
	</svg>
);

/**
 * __HeartbeatsIcon__
 */
const HeartbeatsIcon = ({ label, primaryColor, secondaryColor, size, testId }: IconProps) => (
	<Icon
		label={label}
		primaryColor={primaryColor}
		secondaryColor={secondaryColor}
		size={size}
		testId={testId}
		glyph={HeartbeatsIconGlyph}
	/>
);

export default HeartbeatsIcon;
